
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RepoErrorBanner',

  props: {
    integrationLabel: {
      type: String,
      required: true
    }
  }
})
